import React from "react";
import "@/App.css";
import { Hexagon, Crown } from "lucide-react";

/* ============================================================
   EIGOO · Sports Terminal — Sovereign Coming Soon
   ============================================================ */
function App() {
  return (
    <div className="App coming-soon-root" data-testid="coming-soon-root">
      {/* Centerpiece */}
      <main className="cs-stage" data-testid="coming-soon-stage">
        <div className="cs-glyph" data-testid="cs-glyph">
          <Hexagon className="cs-hex" strokeWidth={1.3} />
          <Crown className="cs-crown" strokeWidth={1.8} />
          <span className="cs-halo" aria-hidden="true" />
        </div>

        <div
          className="cs-eyebrow font-mono-data"
          data-testid="cs-status-eyebrow"
        >
          <span className="cs-dot" /> Status · Dry-Dock · Q3 2026
        </div>

        <h1 className="cs-title" data-testid="cs-title">
          EIGOO{" "}
          <span className="cs-bullet" aria-hidden="true">
            ·
          </span>{" "}
          <span className="cs-title-soft">Sports Terminal</span>
        </h1>

        <p className="cs-subtitle" data-testid="cs-subtitle">
          In Dry-Dock for Structural Refit.{" "}
          <span className="cs-emph">Resuming Q3 2026.</span>
        </p>

        <a
          href="https://eigooinc.net/partners"
          target="_blank"
          rel="noopener noreferrer"
          className="cs-cta"
          data-testid="cs-partners-cta"
        >
          <span className="cs-cta-bracket">[</span>
          <span className="cs-cta-label">CHECK OUT OUR PARTNERS</span>
          <span className="cs-cta-bracket">]</span>
          <span className="cs-cta-shimmer" aria-hidden="true" />
        </a>

        <div className="cs-rule" aria-hidden="true" />

        <p className="cs-fineprint" data-testid="cs-fineprint">
          The hull is being re-rigged for the next ascension. Keep your bearings;
          the signal will return brighter.
        </p>
      </main>

      <footer className="cs-footer" data-testid="cs-footer">
        <span className="font-mono-data cs-footer-text">
          Propelled by <span className="cs-footer-brand">EIGOO INC.</span>
        </span>
      </footer>
    </div>
  );
}

export default App;
